export class DashboardCenter {

    private internalId: string;
    private name: string;
    private active: boolean;
    private latitude: number;
    private longitude: number;

    constructor(internalId?: string,
                name?: string,
                active?: boolean,
                latitude?: number,
                longitude?: number) {
                    this.internalId = internalId;
                    this.name = name;
                    this.active = active;
                    this.latitude = latitude;
                    this.longitude = longitude;
        }

    public get InternalId(): string {
        return this.internalId;
    }
    public get Name(): string {
        return this.name;
    }
    public get Active(): boolean {
        return this.active;
    }
    public get Latitude(): number {
        return this.latitude;
    }
    public get Longitude(): number {
        return this.longitude;
    }


    public set InternalId(internalId: string) {
        this.internalId = internalId;
    }
    public set Name(name: string) {
        this.name = name;
    }
    public set Active(active: boolean) {
        this.active = active;
    }
    public set Latitude(latitude: number) {
        this.latitude = latitude;
    }
    public set Longitude(longitude: number) {
        this.longitude = longitude;
    }

}
